import React from 'react';
import ReactDOM from 'react-dom/client';
import { App } from '@/App';
import { applyTheme, DEFAULT_THEME } from '@/themes/registry';
import { initFaro } from '@/reporting/faro';
import { initCloudflareAnalytics } from '@/reporting/cfAnalytics';
import { trackPageView } from '@/reporting/analytics';
import './base.css';

// Marketing site is dark-only: pin the production theme before first paint.
applyTheme(DEFAULT_THEME);

// Product analytics: page view + (env-gated) Faro RUM + Cloudflare Web Analytics.
trackPageView();
initFaro();
initCloudflareAnalytics();

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
